import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

import Profile from "./pages/profile";
import Profile2 from "./pages/profile/Profile";
import Settings from "./pages/settings";
import Settings2 from "./pages/settings/Settings";
import Creditz2 from "./pages/creditz-old";
import Creditz from "./pages/creditz/creditz";
import SignIn from "./pages/signin";
import Notifications from "./pages/notifications/notifications";
import Connections from "./pages/connections";
import FindPage from "./pages/findPage";
import Search from "./pages/search/Search";
import Messages from "./pages/messages";
import UserProfile from "./pages/userProfile";
import UserProfilesss from './pages/profile/userprofile'
import OtherProfilesss from './pages/OtherProfiles/otherprofile'
// import Home from "./pages/home";
import HomeScreen from "./pages/HomeScreen/homescreen";
import Home from './pages/home'
import Onboarding from "./pages/onboarding";
import EditProfile from "./pages/profile/EditProfile";
import ViewCreditz from "./pages/ViewCreditz/viewcreditz";

// Public Routes
import Register from "./pages/register/Register";
import Login from "./pages/signin/Login";
import Welcome from './pages/welcome';


// Components & Style Assets
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./index.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Icons from "./components/Icons"; // Whole icons load from Icons.js file.
import TobBar from "./components/topBar.js";
import { useSelector } from "react-redux";
import SeeAll from "./pages/HomeScreen/seeall";
import AddCreditz from "./pages/AddCreditz/addCreditz";
import SignUpFlow from "./pages/signup";
import Facebook from "./pages/facebook/facebook";
import AllMessages from "./pages/messages/allmessages";
import AddCreditzSteps from "./pages/AddCreditz/addCreditzSteps";
// import AllMessages from "./pages/messages/allmessages";

const PrivateRoutes = () => {
  const { currentUser } = useSelector((state) => ({
    currentUser: state.profile.currentUser,
  }));

  return (
    <Router>
      <Switch>
        <Route exact path="/profile" component={Profile} />

        <Route exact path="/edit-profile" component={EditProfile}>
          <Header />
          <EditProfile />
          <Footer />
        </Route>

        <Route exact path="/messages" component={AllMessages}>
          <Header />
          <AllMessages />
        </Route>


        <Route exact path="/creditz-old" component={Creditz2} />
        <Route exact path="/creditz/connections" component={Connections} />
        <Route exact path="/find" component={FindPage} />

        <Route exact path="/user/:uid" component={UserProfile} />
        <Route exact path="/messages" component={Messages} />

        <Route exact path="/onboarding" component={Onboarding}>
          {currentUser?.completedOnBoarding === false ? <Redirect to="/onboarding" /> : null}
        </Route>

        <Route exact path="/creditz" component={Creditz}>
          <Header />
          <Creditz />
          <Footer />
        </Route>
        <Route exact path="/messages/:id" component={Messages}>
          <Header />
          <Messages />

        </Route>

        <Route exact path="/notifications" component={Notifications}>
          <Header />
          <Notifications />
          <Footer />
        </Route>

        <Route exact path="/Settings" component={Settings2}>
          <Header />
          <Settings2 />
        </Route>


        <Route exact path="/viewcreditz/:id" component={ViewCreditz}>
          <Header />
          <ViewCreditz />
          <Footer />
        </Route>

        <Route exact path="/search" component={Search}>
          <Header />
          <Search />
          <Footer />
        </Route>

        <Route exact path="/my-profile" component={Profile2}>
          <Header />
          <Profile2 />
          <Footer />
        </Route>


        <Route exact path="/profile/:id" component={OtherProfilesss}>
          <Header />
          <OtherProfilesss />
          <Footer />
        </Route>

        <Route exact path="/home" component={HomeScreen}>
          <Header />
          <HomeScreen />
          <Footer />
        </Route>

        <Route exact path="/requests" component={SeeAll}>
          <Header />
          <SeeAll />
          <Footer />
        </Route>

        <Route exact path="/addCreditzSteps" component={AddCreditzSteps}>
          <Header />
          <AddCreditzSteps />
          <Footer />
        </Route>

        <Route exact path="/AddCreditz">
          <Header />
          <AddCreditz />

        </Route>

        <Route exact path="/facebook">
          <Header />
          <Facebook />

        </Route>

        <Redirect to="/my-profile" />
      </Switch>
      <Icons />
    </Router>
  );
};

const PublicRoutes = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Welcome} >
          <Welcome />
          <Footer />
        </Route>
        <Route exact path="/register" component={Register} />
        <Route exact path="/signup" component={SignUpFlow} />
        <Route exact path="/signIn" component={SignIn} />
        <Route exact path="/login" component={Login}>
          <Login />
          <Icons />
        </Route>
        <Redirect to="/" />
      </Switch>
      <Icons />
    </Router>
  );
};
export { PrivateRoutes, PublicRoutes };